import React, { memo } from "react";
import { BsInfoCircle } from "react-icons/bs";
import { Handle, Position } from "reactflow";
import { useNodeId } from "reactflow";

export default memo(({ data, isConnectable }) => {
  const nodeId = useNodeId();

  return (
    <>
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
      />
      <div className="rectangle">
        {data.nodeType === "dataset" && (
          <div className="rect-node-name">
            {data.dataIcon} {data.label}{" "}
          </div>
        )}
        {data.nodeType === "task" && (
          <div className="rect-node-name">
            {data.taskIcon} {data.label}{" "}
          </div>
        )}
      </div>
      <BsInfoCircle
        className="icon-collapse-expand"
        size={15}
        onClick={data.onClick}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={data.target}
        // style={{ top: 10, background: '#555' }}
        isConnectable={isConnectable}
      />
    </>
  );
});
